import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import MultiLayerFilter from '@features/filter/Common/MultiLayerFilter';
import { allFilterPages, formatMultilayerColorsOptions } from '@features/filter/static/filterUtil';

const MultilayerColors = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const [selectedMultilevelData, setSelectedMultiLevelData] = useState([]);
	const multiLevelFilterStore = useSelector((store) => store.multiLevelFIlterStore);
	const currentSelectedFilterLevel = multiLevelFilterStore?.currentSelectedFilterLevel;

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setSelectedMultiLevelData(multiLevelFilterStore?.multiLevelFilters);
	}, [multiLevelFilterStore]);

	useEffect(() => {
		setData(allData);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.FABRIC_LIST_TAB]: dependentFilterList?.colorGroupList,
		[allFilterPages.TRIMS_LIST_TAB]: dependentFilterList?.colorGroupList
	};

	const onFetchData = async () => {
		let dependentList = filterData[filterPageName];
		const options = formatMultilayerColorsOptions(dependentList);
		setAllData(options);
		setData(options);
	};

	return (
		<MultiLayerFilter
			filterOptions={data}
			selectedField={selectedField}
			selectedMultilevelData={selectedMultilevelData}
			allOptions={allData}
			setFilterOptions={setData}
			currentSelectedFilterLevel={currentSelectedFilterLevel}
			type="MULTILAYER_COLORS"
			isOpenFourthLayerOnSearch={false}
		/>
	);
};

export default MultilayerColors;
